/**
 * @prettier
 */

import React, { useReducer } from 'react'
import HomeContext from './HomeContext'
import homeReducer from './homeReducer'
import {
  ADD_HOME,
  DELETE_HOME,
  UPDATE_HOME,
  SET_CURRENT,
  CLEAR_CURRENT,
  GET_HOMES,
  HOME_ERROR,
} from '../types'
import axios from 'axios'

const HomeState = (props) => {
  const initialState = {
    homes: [],
    currentHome: null,
  }

  const [state, dispatch] = useReducer(homeReducer, initialState)

  const getHome = async (id) => {
    try {
      const res = await axios.get(`/api/homes/${id}`)
      return res.data
    } catch (err) {
      dispatch({ type: HOME_ERROR, payload: err })
    }
  }

  const getHomes = async () => {
    try {
      const res = await axios.get('/api/homes')
      console.log('res.data', res.data)
      dispatch({ type: GET_HOMES, payload: res.data })
      return res.data
    } catch (err) {
      dispatch({ type: HOME_ERROR, payload: err })
    }
  }

  const addHome = async (home) => {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    }
    try {
      const res = await axios.post('/api/homes', home, config)
      dispatch({ type: ADD_HOME, payload: res.data })
      return res.data
    } catch (err) {
      dispatch({ type: HOME_ERROR, payload: err })
    }
  }

  const updateHome = async (home) => {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    }
    try {
      const res = await axios.put(`/api/homes/${home._id}`, home, config)
      dispatch({ type: UPDATE_HOME, payload: res.data })
    } catch (err) {
      dispatch({ type: HOME_ERROR, payload: err })
    }
  }

  const deleteHome = async (id) => {
    try {
      await axios.delete(`/api/homes/${id}`)
      dispatch({ type: DELETE_HOME, payload: id })
    } catch (err) {
      dispatch({ type: HOME_ERROR, payload: err })
    }
  }

  const setCurrentHome = (home) => {
    dispatch({ type: SET_CURRENT, payload: home })
  }

  const clearCurrentHome = () => {
    dispatch({ type: CLEAR_CURRENT })
  }

  return (
    <HomeContext.Provider
      value={{
        homes: state.homes,
        currentHome: state.currentHome,
        getHome,
        getHomes,
        addHome,
        updateHome,
        deleteHome,
        setCurrentHome,
        clearCurrentHome,
      }}
    >
      {props.children}
    </HomeContext.Provider>
  )
}

export default HomeState
